import Toggle from '@atlaskit/toggle';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import { useEffect } from 'react';
import { connect } from 'react-redux';

interface ToggleField {
    isEdit: boolean,
    value: boolean,
    onChange: (value: boolean) => any,
}

const ToggleField = ({isEdit, value, onChange}: ToggleField) => {
    return !isEdit
    ? <>{
        Boolean(value)
        ? 'Ja'
        : 'Nee'
    }</>
    : <div style={{width: '100%'}}>
        <Toggle
            onChange={() => onChange(!value)}
            isChecked={!!value}
            size="large"
        />
    </div>
}

export default connect()(ToggleField);